import { setContext } from '@apollo/client/link/context';
import authTokenUtil from '../../account/authTokenUtil';
import visitorAuthTokenUtil from '../../account/visitorAuthTokenUtil';
import { isPublicViewPath } from '../../utils/useIsPublicView';

function getAuthToken() {
  return isPublicViewPath(window.location.pathname)
    ? visitorAuthTokenUtil.get()
    : authTokenUtil.get();
}

export default setContext(() => {
  const authToken = getAuthToken();
  const headers = authToken ? { authorization: authToken } : {};
  return { headers };
});
